import React from 'react';
import { ArrowRight } from 'lucide-react';
export function SalesLetterSection() {
  return <>
      <section className="py-10 md:py-16 px-4 bg-white" data-id="element-93">
        <div className="max-w-[800px] mx-auto" data-id="element-94">
          {/* Identification Section */}
          <div className="mb-10" data-id="element-95">
            <h2 className="text-[26px] md:text-[32px] text-primary-dark mb-6 text-center" data-id="element-96">
              Esto es para vos si...
            </h2>

            <ul className="space-y-3" data-id="element-97">
              <li className="flex items-start gap-3" data-id="element-98">
                <span className="text-pain font-bold text-[18px] leading-none mt-0.5" data-id="element-99">
                  ✗
                </span>
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-100">
                  <strong data-id="element-101">Seguiste una receta</strong> de YouTube — y la
                  emulsión se cortó sin que pudieras explicar por qué.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-102">
                <span className="text-pain font-bold text-[18px] leading-none mt-0.5" data-id="element-103">
                  ✗
                </span>
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-104">
                  <strong data-id="element-105">No sabés cuánto</strong> dura lo que hacés — ni cómo
                  saber si ya no sirve.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-106">
                <span className="text-pain font-bold text-[18px] leading-none mt-0.5" data-id="element-107">
                  ✗
                </span>
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-108">
                  <strong data-id="element-109">Compraste ingredientes que</strong> no encontraste o
                  no sabés cómo reemplazar en tu país.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-110">
                <span className="text-pain font-bold text-[18px] leading-none mt-0.5" data-id="element-111">
                  ✗
                </span>
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-112">
                  <strong data-id="element-113">Buscaste información y</strong> encontraste cien
                  versiones distintas — todas contradictorias.
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-114">
                <span className="text-pain font-bold text-[18px] leading-none mt-0.5" data-id="element-115">
                  ✗
                </span>
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-116">
                  <strong data-id="element-117">Ya descargaste algún</strong> PDF que prometía mucho —
                  y era más de lo mismo: recetas sueltas sin explicación
                  técnica.
                </p>
              </li>
            </ul>

            <p className="text-[18px] font-bold text-pain text-center mt-8 mb-6" data-id="element-118">
              Si dijiste sí a cualquiera — seguí leyendo.
            </p>

            <div className="mt-8 p-6 bg-cream border-t border-b border-accent text-center" data-id="element-119">
              <p className="text-[22px] md:text-[26px] italic text-primary-dark font-serif" data-id="element-120">
                El problema nunca fue tu capacidad. Fue que nadie te dio una
                guía que realmente funcionara.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 px-4 bg-cream" data-id="element-121">
        <div className="max-w-[800px] mx-auto" data-id="element-122">
          {/* Problem Agitation Section */}
          <div className="mb-10" data-id="element-123">
            <h2 className="text-[26px] md:text-[32px] text-primary-dark mb-4" data-id="element-124">
              El problema que nadie nombra
            </h2>
            <p className="text-[16px] leading-[1.6] mb-6" data-id="element-125">
              <strong data-id="element-126">No</strong> es que no querés hacerlo bien. Es que el
              sistema de información gratuita sobre cosmética natural está{' '}
              <strong data-id="element-127">roto por diseño.</strong>
            </p>

            <ul className="space-y-4" data-id="element-128">
              <li className="flex items-start gap-3" data-id="element-129">
                <ArrowRight className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-130" />
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-131">
                  <strong data-id="element-132">Las recetas de Pinterest</strong> —{' '}
                  <span className="italic text-muted" data-id="element-133">
                    no incluyen proporciones exactas. Te dan ingredientes, no
                    fórmulas. Resultado: emulsiones cortadas y frustración.
                  </span>
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-134">
                <ArrowRight className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-135" />
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-136">
                  <strong data-id="element-137">Los videos de YouTube</strong> —{' '}
                  <span className="italic text-muted" data-id="element-138">
                    muestran el proceso pero omiten los datos técnicos críticos:
                    conservantes, pH, tiempo de vida útil. Todo lo que importa,
                    fuera de cámara.
                  </span>
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-139">
                <ArrowRight className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-140" />
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-141">
                  <strong data-id="element-142">Los blogs de cosmética</strong> —{' '}
                  <span className="italic text-muted" data-id="element-143">
                    se contradicen entre sí. Cada uno tiene su versión. No hay
                    forma de saber cuál es correcta sin formación técnica
                    previa.
                  </span>
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-144">
                <ArrowRight className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-145" />
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-146">
                  <strong data-id="element-147">Los ebooks genéricos</strong> —{' '}
                  <span className="italic text-muted" data-id="element-148">
                    eran información reciclada sin estructura. Pagaste por algo
                    que no te llevó a ningún lado.
                  </span>
                </p>
              </li>
              <li className="flex items-start gap-3" data-id="element-149">
                <ArrowRight className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-150" />
                <p className="text-[16px] leading-[1.5] text-ink" data-id="element-151">
                  <strong data-id="element-152">Los cursos online mediocres</strong> —{' '}
                  <span className="italic text-muted" data-id="element-153">
                    clases inconexas, sin soporte real, sin troubleshooting. Te
                    dejaron sola frente al problema.
                  </span>
                </p>
              </li>
            </ul>

            <div className="mt-8 p-6 bg-white border-t border-b border-accent text-center" data-id="element-154">
              <p className="text-[22px] md:text-[26px] italic text-primary-dark font-serif" data-id="element-155">
                "La receta decía que era fácil. Y se me cortó todo. Otra vez."
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-16 px-4 bg-pain text-white" data-id="element-156">
        <div className="max-w-[800px] mx-auto" data-id="element-157">
          {/* Solution Reveal Section */}
          <div data-id="element-158">
            <p className="text-[16px] leading-[1.6] mb-4" data-id="element-159">
              <strong data-id="element-160">Pero</strong> vos todavía podés hacer algo. Cuando tenés
              el sistema correcto, los resultados son repetibles. No importa
              dónde estés empezando hoy.
            </p>
            <p className="text-[16px] leading-[1.6] mb-8" data-id="element-161">
              <strong data-id="element-162">Si</strong> querés formular cosméticos naturales sin miedo
              a equivocarte, sin perder ingredientes y sin buscar información
              contradictorias por toda la web —
            </p>

            <div className="text-center mb-8" data-id="element-163">
              <span className="text-[10px] uppercase font-bold text-accent-light tracking-[0.2em] mb-2 block" data-id="element-164">
                Presentamos:
              </span>
              <h2 className="text-[32px] md:text-[42px] text-cream mb-4" data-id="element-165">
                222 Recetas de Cosméticos Naturales
              </h2>
              <p className="text-[18px] md:text-[20px] italic text-cream/90" data-id="element-166">
                El banco estructurado de fórmulas que te lleva de la
                improvisación a la autonomía real.
              </p>
            </div>

            <div className="space-y-3 mb-8" data-id="element-167">
              <p className="text-[16px] leading-[1.6]" data-id="element-168">
                <strong data-id="element-169">No es otra colección de recetas sueltas.</strong>
              </p>
              <p className="text-[16px] leading-[1.6]" data-id="element-170">
                <strong data-id="element-171">
                  No es un PDF con información básica que ya encontraste gratis.
                </strong>
              </p>
              <p className="text-[16px] leading-[1.6]" data-id="element-172">
                <strong data-id="element-173">Es</strong> una herramienta técnica organizada que te da
                proporciones exactas, criterios de seguridad y un sistema para
                que cada fórmula que hagas funcione.
              </p>
              <p className="text-[16px] leading-[1.6]" data-id="element-174">
                <strong data-id="element-175">222</strong> fórmulas clasificadas por categoría. Cada
                una con los datos que ningún video de YouTube te da:
                conservantes, pH, tiempo de vida útil y qué hacer cuando algo
                falla. Diseñado para que lo uses aunque hoy seas principiante —
                y para que lo sigas usando cuando ya seas experta.
              </p>
            </div>

            <div className="text-center" data-id="element-176">
              <p className="text-[22px] font-serif text-cream mb-4" data-id="element-177">
                Diseñado para que formulés de verdad.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>;
}